import React, { useState, useEffect } from 'react';
import BASE_URL from '../config';
import './Bookings.css';

// Mock data for both upcoming and previous bookings
const mockUpcomingBookings = [
  {
    id: 1,
    type: 'Tours',
    title: 'Magical Malaysia Singapore tour',
    startDate: '12/03/24',
    endDate: '12/06/24',
    image: '/api/placeholder/400/200'
  },
  {
    id: 2,
    type: 'Tours',
    title: 'Bengaluru Malaysia',
    startDate: '12/03/24',
    endDate: '12/06/24',
    image: '/api/placeholder/400/200'
  },
];

const mockPreviousBookings = [
  {
    id: 3,
    type: 'Tours',
    title: 'Bengaluru Pondicherry',
    startDate: '12/03/24',
    endDate: '12/06/24',
    image: '/api/placeholder/400/200'
  },
  {
    id: 4,
    type: 'Visa',
    title: 'England (visa)',
    issueDate: '12/03/24',
    image: '/api/placeholder/400/200'
  },
  {
    id: 1,
    type: 'Tours',
    title: 'Magical Malaysia Singapore tour',
    startDate: '12/03/24',
    endDate: '12/06/24',
    image: '/api/placeholder/400/200'
  },
  {
    id: 2,
    type: 'Tours',
    title: 'Bengaluru Malaysia',
    startDate: '12/03/24',
    endDate: '12/06/24',
    image: '/api/placeholder/400/200'
  },
  {
    id: 3,
    type: 'Tours',
    title: 'Bengaluru Pondicherry',
    startDate: '12/03/24',
    endDate: '12/06/24',
    image: '/api/placeholder/400/200'
  },
  {
    id: 4,
    type: 'Visa',
    title: 'England (visa)',
    issueDate: '12/03/24',
    image: '/api/placeholder/400/200'
  },
  
];

const BookingsComponent = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeBookingType, setActiveBookingType] = useState('Upcoming'); // State for upcoming/previous bookings
  const [activeBookingTab, setActiveBookingTab] = useState('All'); // State for booking tabs
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;

  useEffect(() => {
    // Simulating API call
    const fetchBookings = async () => {
      try {
        const response = await fetch('{{baseurl}}/api/user_tour/tour_id/itinerary');
        // Fetch bookings based on the active booking type (Upcoming/Previous)
        if (activeBookingType === 'Upcoming') {
          setBookings(mockUpcomingBookings);
        } else {
          setBookings(mockPreviousBookings);
        }
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch bookings');
        setLoading(false);
      }
    };

    fetchBookings();
  }, [activeBookingType]); // Dependency on activeBookingType to fetch new data

  const totalPages = Math.ceil(bookings.length / itemsPerPage);
  const paginatedBookings = bookings.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleRedirect = () => {
    window.location.href = 'https://www.youtube.com'; 
    
  };

  // Function to fetch booking details from API
const fetchBookingDetails = async (booking_id, user_tour_id) => {
  try {
    const response = await fetch(`${BASE_URL}/api/booking/${booking_id}?user_tour_id=${user_tour_id}`);
    if (!response.ok) throw new Error('Network response was not ok');
    const data = await response.json();
    // You can set this data in state or handle as needed
    console.log('Booking details:', data);
    return data;
  } catch (error) {
    console.error('Failed to fetch booking details:', error);
    return null;
  }
};

const handleViewDetails = async (booking) => {
  // You may need to get user_tour_id from booking or elsewhere
  const user_tour_id = booking.user_tour_id || '';
  await fetchBookingDetails(booking.id, user_tour_id);
  // You can redirect or show modal with details here
  // window.location.href = 'https://www.youtube.com'; // Remove or replace as needed
};

  const tabs = ['All', 'Tours', 'Flights', 'Bus', 'Visa'];

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="bookings-container">
      <div style={{fontWeight:'500',fontSize:'200%', marginBottom: '20px'}}>Bookings</div>
      <div className="tabs">
        <button 
          className={`tab ${activeBookingType === 'Upcoming' ? 'tab-active' : ''}`}
          onClick={() => {
            setActiveBookingType('Upcoming');
            setCurrentPage(1); // Reset to first page
          }}
        >
          Upcoming
        </button>
        <button 
          className={`tab ${activeBookingType === 'Previous' ? 'tab-active' : ''}`}
          onClick={() => {
            setActiveBookingType('Previous');
            setCurrentPage(1); // Reset to first page
          }}
        >
          Previous bookings
        </button>
      </div>
      <div className='booking-content'>
        <div className="tab-container">
          {tabs.map(tab => (
            <button
              key={tab}
              onClick={() => setActiveBookingTab(tab)}
              className={`offer-tab ${activeBookingTab === tab ? 'active' : ''}`}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="booking-list">
          {paginatedBookings.map(booking => (
            <div key={booking.id} className="booking-card" style={{ backgroundImage: `url(${booking.image})` }}>
              <div className="booking-info">
                <h2>{booking.title}</h2>
                <p>{booking.startDate} - {booking.endDate || booking.issueDate}</p>
                <div>
                  <button onClick={() => handleViewDetails(booking)} className="view-details">View Details</button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="pagination">
          <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
            &laquo;
          </button>
          <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
            &lsaquo;
          </button>
          {[...Array(totalPages).keys()].map(page => (
            <button
              key={page + 1}
              onClick={() => setCurrentPage(page + 1)}
              className={`page-number ${currentPage === page + 1 ? 'active' : ''}`}
            >
              {page + 1}
            </button>
          ))}
          <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>
            &rsaquo;
          </button>
          <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}>
            &raquo;
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingsComponent;
